// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__6CVR4","BreadTop":"BurgerIngredient__BreadTop__3iiM8","Seeds1":"BurgerIngredient__Seeds1__3R7tP","Seeds2":"BurgerIngredient__Seeds2__j-6QX","Meat":"BurgerIngredient__Meat__1Vbzy","Cheese":"BurgerIngredient__Cheese__2rLdI","Salad":"BurgerIngredient__Salad__2KoeS","Bacon":"BurgerIngredient__Bacon__2zjAG"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 39
// module chunks = 0